var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buyer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PO---1",
    transform: "translate(-1186, -294)",
    fill: "#3A3A3C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1154, 219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(32, 75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17 L18,17 L18,19 L0,19 L0,17 Z M10,11.1716 L16.0711,5.1005 L17.4853,6.51472 L9,15 L0.51472,6.51472 L1.92893,5.1005 L8,11.1716 L8,0 L10,0 L10,11.1716 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBlack);
export default __webpack_public_path__ + "static/media/download-icon-black.c68a6a136a035c2eb2a3d1ccce26349b.svg";
export { ForwardRef as ReactComponent };